import { useContext } from 'react'

import { FormattedMessage } from 'react-intl'
import Flex from 'styled-flex-component'

import { CampaignContext } from '@context/Campaign'
import { PostCampaignReportListViewHeadersItem } from '../ListView/Headers/Item'

const PRICE_HIDDEN_ITEMS = ['spend', 'cpe', 'cpm', 'cpv']

const DEFAULT_HEADER_ITEMS = [
  'published',
  'spend',
  'followers',
  'likes',
  'comments',
  'shares',
  'eng',
  'engagementPct',
  'cpe',
  'impressions',
  'impressionsPct',
  'cpm',
  'cpv',
]

type Props = {
  headerItems?: string[]
}

export const AnalyticsPostCampaignReportSubmissionListHeaders: React.FC<Props> = ({
  headerItems = DEFAULT_HEADER_ITEMS,
}) => {
  const {
    campaign: { is_price_hidden: isPriceHidden },
  } = useContext(CampaignContext)

  return (
    <Flex full>
      {headerItems.map((headerItem) =>
        isPriceHidden && PRICE_HIDDEN_ITEMS.includes(headerItem) ? null : (
          <PostCampaignReportListViewHeadersItem
            key={`analytics.postCampaignReport.submission.list.header.${headerItem}`}
          >
            <FormattedMessage
              id={`analytics.postCampaignReport.submission.list.header.${headerItem}`}
            />
          </PostCampaignReportListViewHeadersItem>
        ),
      )}
    </Flex>
  )
}
